const bound = (value, fallback) => {
    const number = Number(value);

    return value === '' || Number.isNaN(number) ? fallback : number;
};

export const handleSteppedIntegerStep = (event) => {
    const step = event.target.closest('[data-stepped-integer-step]');

    if (!step) {
        return;
    }

    event.preventDefault();

    const input = step.closest('[data-stepped-integer]')?.querySelector('input');

    if (!input || input.disabled) {
        return;
    }

    const minimum = bound(input.min, Number.NEGATIVE_INFINITY);
    const maximum = bound(input.max, Number.POSITIVE_INFINITY);
    const current = bound(input.value, 0);

    input.value = Math.min(Math.max(current + Number(step.dataset.steppedIntegerStep), minimum), maximum);

    input.dispatchEvent(new Event('change', {bubbles: true}));
};
